import { createAction } from 'redux-actions';
import { actionKey } from './constants';
import { DeviationViewMode } from '../../publicSession/types';
export var loadDeviation = createAction(actionKey + ".LOAD_DEVIATION", function (deviation) { return ({ deviation: deviation }); });
export var initDeviationPage = createAction(actionKey + ".INIT_DEVIATION", function (deviation, comments) { return ({
    deviation: deviation,
    comments: comments,
}); });
export var enterZoomMode = createAction(actionKey + ".ZOOM_ENTER", function (deviation) { return ({ deviation: deviation }); });
export var exitZoomMode = createAction(actionKey + ".ZOOM_EXIT", function (deviation) { return ({ deviation: deviation }); });
export var fullscreenEntered = createAction(actionKey + ".VIEW.FULLSCREEN_ENTERED", function (deviation) { return ({ deviation: deviation }); });
export var fullscreenExited = createAction(actionKey + ".VIEW.FULLSCREEN_EXITED", function (deviation) { return ({ deviation: deviation }); });
var actionBarMetaCreator = function (actionBar) {
    if (actionBar === void 0) { actionBar = 'primary'; }
    return ({
        actionBar: actionBar,
    });
};
export var toggleCollectionPanel = createAction(actionKey + ".COLLECTION_PANEL.TOGGLE", null, actionBarMetaCreator);
export var showCollectionPanel = createAction(actionKey + ".COLLECTION_PANEL.SHOW", null, actionBarMetaCreator);
export var showGroupsPanel = createAction(actionKey + ".GROUPS_PANEL.SHOW", null, actionBarMetaCreator);
export var hideGroupsPanel = createAction(actionKey + ".GROUPS_PANEL.HIDE", function () { return ({}); });
export var toggleGroupsPanel = createAction(actionKey + ".GROUPS_PANEL.TOGGLE", null, actionBarMetaCreator);
export var hidePanelPopup = createAction(actionKey + ".PANEL_POPUP.HIDE", function () { return ({}); });
export var requestChangeViewMode = createAction(actionKey + ".VIEW.REQUEST_CHANGE_VIEW_MODE", function (viewMode, deviation) { return ({
    viewMode: viewMode,
    deviation: deviation,
}); });
export var requestToggleTheaterView = function (deviation) {
    return requestChangeViewMode(DeviationViewMode.Theater, deviation);
};
export var requestToggleFullscreenView = function (deviation) {
    return requestChangeViewMode(DeviationViewMode.Fullscreen, deviation);
};
export var setScreenSize = createAction(actionKey + ".VIEW.SET_SCREEN_SIZE", function (width, height) { return ({ width: width, height: height }); });
//# sourceMappingURL=actions.js.map